'use strict';
{
	const canvashelper = require('./tools/canvashelper');

	/**
	 * tools
	 * @type {Object}
	 * @namespace cheetahGrid.tools
	 * @memberof cheetahGrid
	 */
	module.exports = {
		canvashelper,
	};
}